window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {

    window.$ = window.jQuery = require("jquery");
    window.Popper = require('popper.js').default;

    require('bootstrap');

} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');


import refreshCsrfForModalLogin from './helpers/login-modal';

axios.interceptors.response.use(response => {
    return response;
}, error => {
    //TODO: It would probably be nice if we could retry the original request and access original promise if ajax login is successful, somehow?!?
    // An expired session on a POST fails the CSRF check (419) before the auth middleware can return 401
    if(error.response && [401, 419].includes(error.response.status) && document.getElementById('login-modal') !== null) {
        refreshCsrfForModalLogin();
    }
    return Promise.reject(error);
});


window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
